
    import './styles.scoped.css';
    export default {
  "root": "_root_48piw_3",
  "tools": "_tools_48piw_11",
  "tools-filtering": "_tools-filtering_48piw_16",
  "tools-filtering-content": "_tools-filtering-content_48piw_20",
  "tools-align-right": "_tools-align-right_48piw_23",
  "tools-pagination": "_tools-pagination_48piw_27",
  "tools-preferences": "_tools-preferences_48piw_27",
  "tools-small": "_tools-small_48piw_33",
  "table": "_table_48piw_39",
  "table-layout-fixed": "_table-layout-fixed_48piw_43",
  "wrapper": "_wrapper_48piw_47",
  "cell": "_cell_48piw_53",
  "header-cell": "_header-cell_48piw_58",
  "header-cell-sticky": "_header-cell-sticky_48piw_67",
  "header-cell-sortable": "_header-cell-sortable_48piw_74",
  "body-cell": "_body-cell_48piw_87",
  "body-cell-wrap": "_body-cell-wrap_48piw_92",
  "row": "_row_48piw_105",
  "row-selected": "_row-selected_48piw_108",
  "cell-merged": "_cell-merged_48piw_123",
  "cell-merged-content": "_cell-merged-content_48piw_127",
  "empty": "_empty_48piw_134",
  "loading": "_loading_48piw_138",
  "selection-control": "_selection-control_48piw_142",
  "sorting-icon": "_sorting-icon_48piw_153",
  "header-cell-disabled": "_header-cell-disabled_48piw_160",
  "header-cell-sorted": "_header-cell-sorted_48piw_160",
  "header-cell-content": "_header-cell-content_48piw_160",
  "header-cell-ascending": "_header-cell-ascending_48piw_204",
  "header-cell-descending": "_header-cell-descending_48piw_205",
  "header-cell-text": "_header-cell-text_48piw_209",
  "header-cell-text-wrap": "_header-cell-text-wrap_48piw_209",
  "sticky-scrollbar": "_sticky-scrollbar_48piw_215",
  "sticky-scrollbar-content": "_sticky-scrollbar-content_48piw_225",
  "sticky-scrollbar-visible": "_sticky-scrollbar-visible_48piw_228",
  "header-secondary": "_header-secondary_48piw_232",
  "header-controls": "_header-controls_48piw_245",
  "thead-active": "_thead-active_48piw_249"
};
  